import checkboxSettings from 'app/common/containers/settings/checkboxSettings';

export default checkboxSettings;
